import { MenuLink } from '../types';

export const menuLinks: Array<MenuLink> = [
  {
    name: 'Characters',
    to: '/characters',
  },
  {
    name: 'Episodes',
    to: '/episodes/season/1',
  },
  {
    name: 'Locations',
    to: '/locations',
  },
];